'use strict';

const Site = require('./site');

module.exports = Site.extend({
    urlRoot: '/consumer'
});
